import { call, put, takeEvery } from 'redux-saga/effects';
import { addressActionCreators, AddressActionKeys, IAddress, UpdateAddressFromAxAddress } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../addressApi';

function* updateAddressFromAxAddressSaga(action: UpdateAddressFromAxAddress) {
  const response: IApiExecuteRespone<IAddress[]> = yield call(api.UpdateAddressFromAxAddress, action.payload);
  yield put(addressActionCreators.toggleSaving(action.payload.addressId));

  if (!response.requestFailed && response.value) {
    if (response.value) {
      yield put(addressActionCreators.setAddresses(response.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }
  yield put(addressActionCreators.toggleSaving(action.payload.addressId));
}

export function* watchUpdateAddressFromAxAddress() {
  yield takeEvery(AddressActionKeys.UPDATE_ADDRESS_FROM_AX_ADDRESS, updateAddressFromAxAddressSaga);
}
